/**
 * Polyfills for Node.js environments that don't have web streams
 * This file should be imported before any code that uses undici/fetch
 */

// Only apply polyfills in Node.js environment (not browser)
if (typeof window === "undefined" && typeof global !== "undefined") {
  // Check if we need ReadableStream polyfill
  if (typeof ReadableStream === "undefined") {
    try {
      // Try to import from node:stream/web (Node 18+)
      // Use dynamic import to avoid webpack issues
      let streams;
      try {
        streams = require("node:stream/web");
      } catch (e) {
        // If node:stream/web is not available, try the older require
        try {
          streams = require("stream/web");
        } catch (e2) {
          // Fallback to polyfill
          streams = require("web-streams-polyfill");
        }
      }

      if (streams.ReadableStream) {
        global.ReadableStream = streams.ReadableStream;
      }
      if (streams.WritableStream) {
        global.WritableStream = streams.WritableStream;
      }
      if (streams.TransformStream) {
        global.TransformStream = streams.TransformStream;
      }
    } catch (e) {
      console.warn("ReadableStream polyfill failed to load:", e.message);
    }
  }

  // Ensure TextEncoder/TextDecoder are available
  if (typeof TextEncoder === "undefined") {
    try {
      const { TextEncoder, TextDecoder } = require("util");
      global.TextEncoder = TextEncoder;
      global.TextDecoder = TextDecoder;
    } catch (e) {
      console.warn(
        "TextEncoder/TextDecoder polyfill failed to load:",
        e.message
      );
    }
  }
}
